/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-children-prop */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { logOut } from 'Screens/Login/actions/Actions';
import { useIntl } from 'react-intl';
import SideBarBadge from '../../SideBarBadge';
import { ShortcutContext } from 'Context/Shortcut';
import DropdownItem from './UserDropdownItem';
import { DropdownMenu, Hr } from './styled';

const UserDropdown = ({ modals, closeMenu }) => {
  const dispatch = useDispatch();
  const shortcutContext = useContext(ShortcutContext);
  const {
    Help, Extras, About, Preferences, WhatsNew
  } = modals;

  const intl = useIntl();
  const preferencesLabel = intl.formatMessage({ id: 'user.menu.preferences' });
  const shortcutsLabel = intl.formatMessage({ id: 'user.menu.shortcuts' });
  const faradayApiLabel = intl.formatMessage({ id: 'user.menu.faraday.api' });
  const helpLabel = intl.formatMessage({ id: 'user.menu.help' });
  const whatsNewLabel = intl.formatMessage({ id: 'user.menu.whatsNew' });
  const whatsNewBadgeLabel = intl.formatMessage({ id: 'user.menu.whatsNew.badge' });
  const extrasLabel = intl.formatMessage({ id: 'user.menu.extras' });
  const aboutLabel = intl.formatMessage({ id: 'user.menu.about' });
  const logoutLabel = intl.formatMessage({ id: 'user.menu.logout' });

  const openShortcutsHelp = () => {
    closeMenu();
    shortcutContext?.trigger('mod+/');
  };

  return (
    <DropdownMenu onClick={ (e) => e.stopPropagation() }>
      <DropdownItem Modal={ Preferences } shortcut="mod+,">{ preferencesLabel }</DropdownItem>
      <DropdownItem action={ openShortcutsHelp } shortcut="mod+/">{ shortcutsLabel }</DropdownItem>
      <Hr className="h-menu-separator m-0" />
      <DropdownItem link="/api-definitions" >{ faradayApiLabel }</DropdownItem>
      <DropdownItem Modal={ Help }>{ helpLabel }</DropdownItem>
      <DropdownItem
        Modal={ WhatsNew }
        badge={ WhatsNew.hasUnseen ? <SideBarBadge label={ whatsNewBadgeLabel } className="user_whats_new_badge" /> : undefined }
      >
        { whatsNewLabel }
      </DropdownItem>
      <DropdownItem Modal={ Extras }>{ extrasLabel }</DropdownItem>
      <DropdownItem Modal={ About }>{ aboutLabel }</DropdownItem>
      <DropdownItem action={ () => dispatch(logOut()) }>{ logoutLabel }</DropdownItem>
    </DropdownMenu>
  );
};

UserDropdown.propTypes = {
  modals: PropTypes.shape({
    Extras: PropTypes.object.isRequired,
    Help: PropTypes.object.isRequired,
    About: PropTypes.object.isRequired,
    Preferences: PropTypes.object.isRequired,
    WhatsNew: PropTypes.object.isRequired
  }).isRequired,
  closeMenu: PropTypes.func.isRequired

};

export default UserDropdown;
